import { z } from 'zod'

const checkoutPassengerSchema = z.object({
  firstName: z.string(),
  lastName: z.string(),
  birthDate: z.string(),
  gender: z.enum(['MALE', 'FEMALE']),
  travellerKey: z.string(),
})

export const checkoutPassengersCountSchema = z.object({
  adults: z.number().default(0),
  babies: z.number().default(0),
  infants: z.number().default(0),
  seniors: z.number().default(0),
  youngsters: z.number().default(0),
})

const checkoutInsuranceOptionSchema = z
  .object({
    cgsLink: z.string().nullable(),
    commissionAgent: z.number(),
    dinLink: z.string().nullable(),
    idAssurance: z.string(),
    idFormule: z.string(),
    nomAssurance: z.string(),
    nomFormule: z.string(),
    primeTms: z.number(),
    prixVente: z.number(),
  })
  .nullable()
  .optional()

export const checkoutSearchSchema = z.object({
  /** Affidium keys (from shop step — used for price cache lookup) */
  journeyKeys: z.array(z.string()),
  offerKey: z.string(),
  transactionKey: z.string(),

  /** Affidium keys for booking (from price response) */
  bookOfferKey: z.string(),
  bookTransactionKey: z.string(),

  departureDate: z.string(),
  destination: z.string(),
  /** Flight info */
  origin: z.string(),
  returnDate: z.string().optional(),
  tripType: z.enum(['one-way', 'round-trip', 'multi-destination']),

  arrivalAirportCode: z.string(),
  /** Airport IATA codes */
  departureAirportCode: z.string(),

  /** Passenger counts */
  passengersCount: checkoutPassengersCountSchema,

  /** Passenger details */
  passengers: z.array(checkoutPassengerSchema),

  insurancePrice: z.string().default('0'),
  /** Prices in euros (string for URL serialization) */
  totalFlightPrice: z.string(),

  /** Whether insurance was selected */
  withInsurance: z.boolean().default(false),

  /** Insurance option details (if selected) */
  insuranceOption: checkoutInsuranceOptionSchema,
})

export type CheckoutSearchParams = z.infer<typeof checkoutSearchSchema>
